const moment = require('moment')

export class Order {
	constructor (attributes) {
		var order = attributes

		if (!order) return null

		for (let key in order) {
			this[key] = order[key]
		}

		this.plan_id = attributes.plan.id
		this.extras = Object.values(attributes.extras)
	}

	getExtraByAttribute (attribute, value) {
		if (!this.extras) { return }

		var self = this.extras
		for (var i = 0; i < self.length; i++) {
			if (self[i] && (typeof self[i][attribute] !== 'undefined') && self[i][attribute] === value) {
				return self[i]
			}
		}

		return null
	}

	findExtraByAttribute (attribute, value) {
		if (!this.extras) { return }

		var self = this.extras
		for (var i = 0; i < self.length; i++) {
			if (self[i] && (typeof self[i][attribute] !== 'undefined') && self[i][attribute] === value) {
				return i
			}
		}

		return null
	}

	removeExtraByAttribute (attribute, value) {
		if (!this.extras) { return }

		var self = this.extras

		var index = this.findExtraByAttribute(attribute, value)
		return index !== null ? self.splice(index, 1) : null
	}

	getRecipeByAttribute (attribute, value) {
		if (!this.recipes) { return }

		var self = this.recipes
		for (var i = 0; i < self.length; i++) {
			if (self[i] && (typeof self[i][attribute] !== 'undefined') && self[i][attribute] === value) {
				return self[i]
			}
		}

		return null
	}

	countItems()
	{
		return (this.extras ? this.extras.map(a => a.quantity).reduce((a, b) => a + b, 0) : 0) + (this.recipes ? this.recipes.map(a => a.quantity).reduce((a, b) => a + b, 0) : 0)
	}

	getPlanPricePerPortion () {
		if (!this.plan) {
			return 0;
		}

		if (this.plan.meals == 0) {
			return 0;
		}

		return this.plan.price / (this.plan.meals * this.plan.people)
	}

	getDiffToFreeShipping () {
		return (this.prices.gross - this.prices.delivery) - 34;
	}
}
